import { render, staticRenderFns } from "./AlumniArticle.vue?vue&type=template&id=39950852&scoped=true&"
import script from "./AlumniArticle.vue?vue&type=script&lang=js&"
export * from "./AlumniArticle.vue?vue&type=script&lang=js&"
import style0 from "./AlumniArticle.vue?vue&type=style&index=0&id=39950852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39950852",
  null
  
)

export default component.exports